export default "__VITE_ASSET__s159QjX4__"